"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedError = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_1 = require("./styled");
var material_1 = require("@mui/material");
var error_icon_1 = require("../error-icon");
var hooks_1 = require("../../hooks");
var SharedError = function (_a) {
    var children = _a.children, text = _a.text;
    var theme = (0, hooks_1.useGracefulTheme)();
    var commonCss = {
        sx: {
            color: theme.text,
        },
    };
    return ((0, jsx_runtime_1.jsxs)(styled_1.SharedErrorWrapper, __assign({ component: material_1.Paper, sx: {
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        } }, { children: [(0, jsx_runtime_1.jsxs)(styled_1.SharedErrorGrid, { children: [(0, jsx_runtime_1.jsx)(error_icon_1.ErrorIcon, { htmlColor: theme.primary, sx: { width: 200, height: 125 } }), (0, jsx_runtime_1.jsxs)(styled_1.SharedErrorWrapper, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, __assign(__assign({}, commonCss), { fontSize: 24, fontWeight: '700', lineHeight: '29px' }), { children: text.sorry })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, __assign(__assign({}, commonCss), { fontSize: 16, fontWeight: '600', lineHeight: '130%', sx: function (_a) {
                                    var palette = _a.palette;
                                    return ({
                                        color: palette.error.main,
                                    });
                                } }), { children: text.errorMessage }))] })] }), (0, jsx_runtime_1.jsxs)(styled_1.SharedErrorWrapper, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, __assign(__assign({}, commonCss), { fontSize: 16, fontWeight: '400', lineHeight: '130%' }), { children: text.message })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, __assign(__assign({}, commonCss), { fontSize: 16, fontWeight: '400', lineHeight: '130%', color: theme.secondary }), { children: children })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({}, __assign(__assign({}, commonCss), { fontSize: 16, fontWeight: '400', lineHeight: '130%' }), { children: text.backSoon }))] })] })));
};
exports.SharedError = SharedError;
